import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'poa';
  showAdmin:boolean =false;
  constructor(private router: Router){
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/') {
          this.showAdmin=false;
        }
        else if (event['url'] == '/readPNR') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/countrymaster') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/currencymaster') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Portmaster') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Chamaster') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/onboarding') {
          this.showAdmin=true;
        }
         else if (event['url'] == '/Contracts') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/NDA') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/AssignEmp') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Exchange') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/ClientUpload') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Bank') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Output') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Bond') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Antidumbing') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Customnotify') {
          this.showAdmin=true;
        }
        else if (event['url'] == '/Exim') {
          this.showAdmin=true;
        }
        else if(event['url']==='/ImportCSV'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/Parts'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/Employee'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/License'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/Dashboard'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/UserRights'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/LicenseAAS'){
          this.showAdmin=true;
        }
        else if(event['url'] == '/AuditReport'){
          this.showAdmin=true;
        }
        else if (event['url'] == '/units-master') {
          this.showAdmin=true; 
        }
      }
    });
  }
}
